import {useEffect, useState} from "react";
import i18n from "i18next";
import {loadPayments} from '@ministrybrands/payments-js/pure';
import {unmountComponentAtNode} from "react-dom";
import {Inertia} from "@inertiajs/inertia";
import AmplifySpinner from "@/Components/AmplifySpinner";

export default function Checkout({state, dispatch, apiKey}) {

    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const paymentsEnv = () => {
        let lowerCasedEnv = state.pbEnv.toLowerCase();

        if (lowerCasedEnv === 'dev1') {
            return 'dev';
        } else if (lowerCasedEnv === 'production') {
            return 'prd';
        } else if (lowerCasedEnv === 'test1') {
            return 'dev';
        } else if (lowerCasedEnv === 'stg') {
            return 'stg';
        } else if (lowerCasedEnv === 'beta') {
            return 'beta';
        } else if (lowerCasedEnv === 'int') {
            return 'int';
        } else {
            return 'dev';
        }
    };

    useEffect(() => {
        let container = document.getElementById("checkout-container");
        const successHandler = e => {
            unmountComponentAtNode(container);
            // setMessage(e.type);
            // @TODO : MVP we want to just show success
            setMessage(i18n.t('buy-flow.purchase-complete'));
            setIsLoading(true);
            // resend the cart so that the backend can activate the modules
            Inertia.post(
                route('manage.buyflow.success'),
                {success: 'success'}
            );
        }

        const errorHandler = e => {
            unmountComponentAtNode(container);
            setMessage(e.type);
            setIsLoading(true);
            Inertia.post(
                route('manage.buyflow.failure'),
                {success: 'failure'}
            );
        }

        document.addEventListener("submissionSuccess", successHandler);
        document.addEventListener("submissionError", errorHandler);

        // clean up
        window.removeEventListener("submissionSuccess", successHandler)
        return () => window.removeEventListener("submissionError", errorHandler)
    }, []) // empty array => run only once

    useEffect(()=> {
        const controller = new AbortController();
        const signal = controller.signal;

        const getPayments = async() => {
            const instance = await loadPayments(paymentsEnv(), apiKey);
            return instance;
        };

        getPayments().then((payments) => {
            dispatch({ type: "isLoadingSession", payload: {isLoadingSession: true}});
            axios.post(route('manage.buyflow.session'), {
                cart: state.cart,
                oneTimePrice: state.oneTimePrice,
                contractTerm: state.toggleValue,
                recurring: {
                    amount: state.totalPrice,
                    frequency: state.billingFrequency
                }
            }, {signal: signal}).then(res => {
                const {sessionId, sessionClientSecret} = res.data;
                const components = payments.components({sessionId, "clientSecret": sessionClientSecret});
                const checkout = components.create("checkout");
                checkout.mount("checkout-container");
            }).then(() => setIsLoading(false)
            ).catch(error => {
                Inertia.post(
                    route('manage.buyflow.failure'),
                    {success: false, message: JSON.stringify(error.response.data.message)}
                );
            }).finally(() => dispatch({type: "isLoadingSession", payload: {isLoadingSession: false}}));
        });

        const destroyPayments = () => {
            controller.abort();
            let node = document.getElementById("checkout-container");
            if (node) {
                node.replaceChildren();
            }
        }

        return () => destroyPayments();
        }, []);

    return <div className="scroll-div">
        <div className="step-container checkout">
            <div className="d-flex justify-content-between header">
                <span className="titles">
                    <span className="step">{i18n.t('buy-flow.step-three')}</span>
                    <span className="step-title">{i18n.t('buy-flow.checkout-page')}</span>
                </span>
            </div>
        </div>
        { isLoading && <AmplifySpinner /> }
        { message.length > 0 &&
            <div id="checkout-message-container">{message}</div>
        }
        { message.length === 0 &&
            <div id="checkout-container" className="checkout-container"></div>
        }
        </div>
}
